module.exports = __webpack_public_path__ + "img/letter1.3443cdf6.jpg";